module.exports = __webpack_public_path__ + "img/logo1.9e295fc4.png";